import { View } from './view'

export const MainV2 = View
